import path from "path";
import { config as loadEnv } from "dotenv";

const rootDir = process.cwd();
// console.log("Root directory:", rootDir);

// Load environment variables from a specific .env file
loadEnv({ path: path.resolve(process.cwd(), "../../.env") });

/** @type {import('next').NextConfig} */
const nextConfig = {
  env: {
    WP_API_URL: process.env.WP_API_URL,
    BUILD_ALL_POST: process.env.BUILD_ALL_POST,
    REVALIDATE_AFTER: process.env.REVALIDATE_AFTER || 120,
    NEXT_PUBLIC_LOCALES: process.env.NEXT_PUBLIC_LOCALES || "de",
    NEXT_PUBLIC_DEFAULT_LOCALE: process.env.NEXT_PUBLIC_DEFAULT_LOCALE || "de",
    BASIC_AUTH_USERNAME: process.env.BASIC_AUTH_USERNAME || "",
    BASIC_AUTH_PASSWORD: process.env.BASIC_AUTH_PASSWORD || "",
    PRODUCTION_BROWSER_SOURCE_MAPS:
      process.env.PRODUCTION_BROWSER_SOURCE_MAPS || "false",
    NEXT_PUBLIC_INTERNAL_ORIGINS:
      process.env.NEXT_PUBLIC_INTERNAL_ORIGINS || "",
    DEFAULT_LOCALE: process.env.NEXT_PUBLIC_DEFAULT_LOCALE || "de", // needed for middleware
    CHECK_ACCESSIBILITY: process.env.CHECK_ACCESSIBILITY || "false",
    FRIENDLY_CAPTCHA_API_KEY: process.env.FRIENDLY_CAPTCHA_API_KEY || "",
    PRIVATE_PAGE_PREVIEW_SECRET: process.env.PRIVATE_PAGE_PREVIEW_SECRET || "",
    BACKEND_USERNAME: process.env.BACKEND_USERNAME || "",
    BACKEND_PASSWORD: process.env.BACKEND_PASSWORD || "",
    BACKEND_HOST: process.env.BACKEND_HOST || "",
    SERVICE_API_URL: process.env.SERVICE_API_URL || "",
    // NODE_ENV: process.env.NODE_ENV || "development",
    ENABLE_CAMPAIGN_BANNER: process.env.ENABLE_CAMPAIGN_BANNER || false,
    ENABLE_DEBUG_LOG: process.env.ENABLE_DEBUG_LOG || "false",
    SEARCH_EXTERNAL_URL: process.env.SEARCH_EXTERNAL_URL || "",
  },

  images: {
    remotePatterns: process.env.IMAGES_DOMAINS?.split(",").map((url) => ({
      protocol: "https",
      hostname: url.trim(),
      pathname: "/**",
    })),
    deviceSizes: [320, 375, 414, 640, 768, 1024, 1280, 1440, 1920, 2560],
    imageSizes: [16, 32, 48, 64, 128, 256, 512],
    minimumCacheTTL: 604800,
  },
  staticPageGenerationTimeout: 120,
  i18n: {
    locales: process.env.NEXT_PUBLIC_LOCALES?.split(",") || ["de"],
    defaultLocale: process.env.NEXT_PUBLIC_DEFAULT_LOCALE || "de",
  },

  compress: true,

  experimental: {
    scrollRestoration: true,
  },

  sassOptions: {
    includePaths: [
      path.join(rootDir, "src", "styles"),
      path.join(rootDir, "..", "..", "node_modules"),
    ],
    additionalData: `@use "global-entrypoint" as *;`,
  },

  webpack(config) {
    config.module.rules.push({
      test: /\.svg$/,
      issuer: { and: [/\.(js|ts)x?$/] },
      use: ["@svgr/webpack"],
    });
    return config;
  },

  trailingSlash: false,
  transpilePackages: [
    "@aleksundshantu.com/aunds-cookie-plugin-react",
    "@aleksundshantu.com/aunds-utils-react",
  ],

  productionBrowserSourceMaps:
    process.env.PRODUCTION_BROWSER_SOURCE_MAPS === "true",

  eslint: {
    ignoreDuringBuilds: true,
  },
  async rewrites() {
    return [
      {
        source: "/api/:path*",
        destination: `${process.env.BACKEND_HOST}/:path*`,
      },
    ];
  },
};

export default nextConfig;
